import { ErrorBanner } from '@/components/error-page/error-banner';
import { streamsAllLoader } from '@/routes/_app.p.marketplace.streams/loader';
import { StreamsFeed } from '@/routes/_app.p.marketplace.streams/streams-feed';

export const clientLoader = streamsAllLoader;

export const ErrorBoundary = ErrorBanner;

export default function CustomStreamsIndex() {
  return <StreamsFeed />;
}
